<template>
  <form v-on:submit.prevent="saveForm" novalidate>
    <LoaderContent v-if="isLoading" :welcomeMessage="false" />

    <div class="form-row">
      <div
        class="form-group col-12 col-md-6"
        :class="{ 'is-invalid': $v.language.$error }"
      >
        <label :for="'language-input-language' + _uid"
          ><span>*</span> Idioma</label
        >
        <selectize
          :id="'language-input-language' + _uid"
          :settings="languageSettings"
          v-model="language"
          required
        >
          <option
            :value="language.name"
            v-for="(language, index) in $store.state.domains.languages"
            :key="index"
          >
            {{ language.id == '4' ? "Alemán" : "" }}
            {{ language.id == '9' ? "Arábica" : "" }}
            {{ language.id == '24' ? "Árabe egipcio" : "" }}
            {{ language.id == '11' ? "Bengalí" : "" }}
            {{ language.id == '28' ? "Birmano" : "" }}
            {{ language.id == '6' ? "Chino (Mandarín)" : "" }}
            {{ language.id == '22' ? "Coreano" : "" }}
            {{ language.id == '34' ? "Kurdo" : "" }}
            {{ language.id == '2' ? "Español" : "" }}
            {{ language.id == '3' ? "Francés" : "" }}
            {{ language.id == '25' ? "Guyaratí" : "" }}
            {{ language.id == '37' ? "Hausa" : "" }}
            {{ language.id == '42' ? "Hebreo" : "" }}
            {{ language.id == '8' ? "Hindú" : "" }}
            {{ language.id == '39' ? "Holandés" : "" }}
            {{ language.id == '74' ? "Húngaro" : "" }}
            {{ language.id == '12' ? "Indonesio" : "" }}
            {{ language.id == '1' ? "Inglés" : "" }}
            {{ language.id == '14' ? "Italiano" : "" }}
            {{ language.id == '5' ? "Japonés" : "" }}
            {{ language.id == '19' ? "Javanés" : "" }}
            {{ language.id == '27' ? "Canarés" : "" }}
            {{ language.id == '41' ? "LSE (Língua de Sinais Espanhola)" : "" }}
            {{ language.id == '30' ? "Malayalam" : "" }}
            {{ language.id == '23' ? "Marathi" : "" }}
            {{ language.id == '31' ? "Oriya" : "" }}
            {{ language.id == '13' ? "Persa" : "" }}
            {{ language.id == '26' ? "Polaco" : "" }}
            {{ language.id == '7' ? "Portugués" : "" }}
            {{ language.id == '15' ? "Punjabi" : "" }}
            {{ language.id == '35' ? "Romeno" : "" }}
            {{ language.id == '10' ? "Russo" : "" }}
            {{ language.id == '36' ? "Somalí" : "" }}
            {{ language.id == '40' ? "Sueco" : "" }}
            {{ language.id == '33' ? "Sundanés" : "" }}
            {{ language.id == '38' ? "Tagalo" : "" }}
            {{ language.id == '32' ? "Tailandés" : "" }}
            {{ language.id == '18' ? "Tamil" : "" }}
            {{ language.id == '20' ? "Telugu" : "" }}
            {{ language.id == '21' ? "Turco" : "" }}
            {{ language.id == '29' ? "Ucranio" : "" }}
            {{ language.id == '16' ? "Urdu" : "" }}
            {{ language.id == '17' ? "Vietnamita" : "" }}
          </option>
        </selectize>
      </div>

      <div
        class="form-group col-12 col-md-6"
        :class="{ 'is-invalid': $v.proficiency.$error }"
      >
        <label :for="'language-input-proficiency' + _uid"
          ><span>*</span> Nivel</label
        >
        <selectize
          :id="'language-input-proficiency' + _uid"
          :settings="proficiencySettings"
          v-model="proficiency"
          required
        >
          <option
            :value="language.id"
            v-for="(language, index) in $store.state.domains
              .language_proficiencies"
            :key="index"
          >
            {{ language.id == '1' ? "Básico" : "" }}
            {{ language.id == '2' ? "Intermedio" : "" }}
            {{ language.id == '3' ? "Avanzado" : "" }}
            {{ language.id == '4' ? "Fluido" : "" }}
          </option>
        </selectize>
      </div>
    </div>

    <p class="small text-right font-italic">
      los campos con * son obligatorios.
    </p>

    <div class="d-flex align-items-center mt-4" v-if="hasButtons">
      <button type="reset" class="btn btn-light mr-auto" @click="reset()">
        Cancelar
      </button>
      <button type="submit" class="btn btn-blue-ml">Guardar</button>
    </div>
  </form>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, requiredIf, minValue } from "vuelidate/lib/validators";
import LoaderContent from "../Loader/LoaderContent.vue";

export default {
  name: "FormLanguage",

  data() {
    return {
      language_proficiency_id: "",
      language: "",
      proficiency: "",

      languageSettings: {
        create: false,
        createOnBlur: false,
        dropdownParent: "body",
      },

      proficiencySettings: {
        create: false,
        createOnBlur: false,
        dropdownParent: "body",
      },

      isLoading: false,

      source: "chatbot",
    };
  },

  props: {
    hasButtons: {
      type: Boolean,
      default: false,
    },

    storeByEventBus: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    LoaderContent,
  },

  mixins: [validationMixin],

  validations: {
    language: { required },
    proficiency: { required },
  },

  mounted() {
    this.initListeners();
  },

  destroyed() {
    this.$EventBus.$off("editingLanguage");
  },

  beforeDestroy() {
    this.$store.commit("LANGUAGES_FORMS", { _uid: this._uid });
  },

  methods: {
    initListeners() {
      this.$EventBus.$on("editingLanguage", (language) => {
        let requestData = "";
        const requestDomainParam = "";
        let requestDomainReturn = "";
        this.isLoading = true;

        if (this.$store.state.domains.languages.length == 0) {
          requestDomainReturn += "languages {id, name},";
        }
        if (this.$store.state.domains.language_proficiencies.length == 0) {
          requestDomainReturn += "languageProficiencies {id, description},";
        }

        if (requestDomainParam.length > 0 || requestDomainReturn.length > 0) {
          requestData += `domains(${requestDomainParam}){${requestDomainReturn}}`;
        }

        if (!language) {
          this.reset(false);
        } else {
          this.language_proficiency_id = language.id;

          requestData += `languageProficiency(id: "${language.id}", userId: ${this.$store.state.user.profile.id}) {
              id,
              language,
              proficiency
            },`;
        }

        this.$store
          .dispatch("graphql_queries/query", requestData)
          .then((response) => {
            if (response && response.languageProficiency) {
              const language = response.languageProficiency;

              this.language = language.language;
              this.proficiency = language.proficiency;
            }

            this.isLoading = false;
          });
      });

      if (this.storeByEventBus) {
        this.$EventBus.$on("storeLanguageFormInSequence", this.storeForm);
      }
    },

    reset(closeModal = true) {
      this.isLoading = false;
      this.$v.$reset();
      if (closeModal) this.$emit("closeModal");
      Object.assign(this.$data, this.$options.data.call(this));
      this.initListeners();
    },

    saveForm() {
      this.$v.$touch();

      if (this.$v.$invalid) {
      } else {
        const data = this.$data;

        this.$store
          .dispatch("user/languageCreateUpdate", data)
          .then((response) => {
            if (response.error) {
              this.$swal(
                "Uoops",
                "Ocorreu um erro ao salvar suas informações",
                "error"
              );
            } else {
              this.$store
                .dispatch(
                  "graphql_queries/query",
                  `
                user( id: "${this.$store.state.user.profile.id}" ){
                  profile{
                    languageProficiencies {
                      id,
                      language,
                      proficiency
                    },
                  }
                }
              `
                )
                .then((updatedData) => {
                  this.$swal("¡Hecho!", "Idioma guardado con éxito", "success");
                  this.reset();
                });
            }
          });
      }
    },

    storeForm() {
      if (this._isDestroyed) return;

      if (this.language.length > 0 && this.proficiency.length > 0) {
        this.$store.commit(
          "LANGUAGES_FORMS",
          Object.assign(this.$data, { _uid: this._uid })
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
